(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["labanana-calculateur-forfaits"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('labanana-calculator'))customElements.define('labanana-calculator',class extends HTMLElement{connectedCallback(){if(this.dataset.initialized)return;this.dataset.initialized='true';const root=this;const raw=JSON.parse(root.querySelector('[data-config]').textContent);const defaults={volume:Number(raw.volume),basket:Number(raw.basket),orderCount:3448,inputMode:'basket',period:'year',billing:'annual',provider:'shopify',externalRate:Number(raw.psp_rate),externalFixed:Number(raw.psp_fixed),externalSubscription:0,plus:true,compareExternal:false,plans:[{name:"Basic",annual:Number(raw.basic_annual),monthly:Number(raw.basic_monthly),rate:Number(raw.basic_rate),fixed:Number(raw.basic_fixed),third:Number(raw.basic_third)},{name:"Grow",annual:Number(raw.grow_annual),monthly:Number(raw.grow_monthly),rate:Number(raw.grow_rate),fixed:Number(raw.grow_fixed),third:Number(raw.grow_third)},{name:"Advanced",annual:Number(raw.advanced_annual),monthly:Number(raw.advanced_monthly),rate:Number(raw.advanced_rate),fixed:Number(raw.advanced_fixed),third:Number(raw.advanced_third)},{name:"Plus",annual:Number(raw.plus_annual),monthly:Number(raw.plus_monthly),rate:Number(raw.plus_rate),fixed:Number(raw.plus_fixed),third:Number(raw.plus_third)}]};function calculate(s){
  const annualVolume=s.volume*(s.period==='month'?12:1);
  if(!Number.isFinite(annualVolume)||annualVolume<0||(s.inputMode!=='orders'&&(!Number.isFinite(s.basket)||s.basket<=0))) throw Error('Renseignez un volume positif ou nul et un panier moyen supérieur à zéro.');
  const orders=s.inputMode==='orders'?s.orderCount*(s.period==='month'?12:1):annualVolume/s.basket;
  if(!Number.isFinite(orders)||orders<0||(annualVolume>0&&orders===0)) throw Error('Le nombre de commandes doit être supérieur à zéro pour un volume encaissé positif.');
  const effectiveBasket=orders>0&&annualVolume>0?annualVolume/orders:(s.inputMode==='orders'?NaN:s.basket);
  const rows=s.plans.map(p=>{
    const ext=s.provider==='external';
    const subscription=(p[s.billing==='annual'?'annual':'monthly']+(ext?s.externalSubscription:0))*12;
    const processing=annualVolume*(ext?s.externalRate:p.rate)/100;
    const fixed=orders*(ext?s.externalFixed:p.fixed);
    const third=ext?annualVolume*p.third/100:0;
    const effectiveRate=((ext?s.externalRate+p.third:p.rate)/100)+(ext?s.externalFixed:p.fixed)/effectiveBasket;
    return {...p,subscription,processing,fixed,third,effectiveRate,total:subscription+processing+fixed+third};
  });
  const ranked=[...rows].sort((a,b)=>a.total-b.total);
  const thresholds=rows.slice(0,-1).map((a,i)=>{
    const b=rows[i+1], delta=b.subscription-a.subscription, saving=a.effectiveRate-b.effectiveRate;
    return {from:a.name,to:b.name,volume:saving>0?Math.max(0,delta/saving):null};
  });
  return {annualVolume,orders,rows,ranked,thresholds};
}
let state=structuredClone(defaults),view='year';
const $=id=>root.querySelector('[data-field="'+id+'"]'),money=v=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(v),num=v=>new Intl.NumberFormat('fr-FR',{maximumFractionDigits:0}).format(v);
const fields=['volume','basket','orderCount','period','billing','externalRate','externalFixed','externalSubscription','compareExternal'];
const labels={annual:'abonnement annuel par mois',monthly:'abonnement mensuel',rate:'commission Shopify Payments en pourcentage',fixed:'frais fixes par paiement',third:'commission Shopify sur PSP externe en pourcentage'};
function rates(){ $('rates').innerHTML=state.plans.map((p,i)=>`<tr><th scope="row">${p.name}</th>${Object.keys(labels).map(k=>`<td><input type="number" min="0" step="${['annual','monthly'].includes(k)?'1':'.01'}" data-plan="${i}" data-key="${k}" aria-label="${p.name} ${labels[k]}" value="${p[k]}"></td>`).join('')}</tr>`).join(''); }
function render(){
 $('basket-wrap').hidden=state.inputMode!=='basket';$('orders-wrap').hidden=state.inputMode!=='orders';$('orders-unit').textContent=state.period==='year'?'commandes / an':'commandes / mois';
 try{
  $('psp-settings').hidden=!state.compareExternal;const relevant=['volume',state.inputMode==='orders'?'orderCount':'basket',...(state.compareExternal?['externalRate','externalFixed','externalSubscription']:[])];
  for(const id of relevant)if(!Number.isFinite(state[id])||state[id]<0)throw Error('Complétez les champs avec des nombres positifs ou nuls.');
  if(state.inputMode==='orders'&&!Number.isInteger(state.orderCount))throw Error('Saisissez un nombre entier de commandes.');
  for(const p of state.plans)for(const k of Object.keys(labels))if(!Number.isFinite(p[k])||p[k]<0)throw Error('Vérifiez les tarifs : aucun champ ne doit être vide ou négatif.');
  const sp=calculate({...state,provider:'shopify'}),psp=calculate({...state,provider:'external'}),factor=view==='year'?1:12,period=view==='year'?'an':'mois';
  const amount=v=>money(v/factor),all=[...sp.rows.map(r=>({...r,provider:'Shopify Payments'})),...(state.compareExternal?psp.rows.map(r=>({...r,provider:'PSP externe'})):[])].sort((a,b)=>a.total-b.total),best=all[0];
  $('error').hidden=true;$('output').hidden=false;
  $('derived').textContent=state.inputMode==='basket'?`≈ ${num(sp.orders/(state.period==='month'?12:1))} commandes ${state.period==='month'?'par mois':'par an'}`:sp.orders>0?`Panier moyen calculé : ${money(sp.annualVolume/sp.orders)}`:'Aucune commande sur la période.';
  const ties=all.filter(r=>Math.abs(r.total-best.total)<.005);
  $('winner').innerHTML=`<div><span class="small-label">LE COÛT LE PLUS BAS DANS CETTE SIMULATION</span><strong>${ties.length>1?'Plusieurs configurations à égalité':`${best.name} + ${best.provider}`}</strong><span>Selon les tarifs renseignés · hors critères fonctionnels</span></div><div class="winner-price">${amount(best.total)}<small>/ ${period}${view==='month'?' en moyenne':''}</small></div>`;
  $('comparison-grid').innerHTML=sp.rows.map((s,i)=>{const e=psp.rows[i];const cell=(r,provider,cls)=>`<div class="cost-cell ${cls} ${Math.abs(r.total-best.total)<.005?'best':''}"><span class="provider-label">${provider}</span><div class="price">${amount(r.total)}</div><span class="price-period">/ ${period}${view==='month'?' en moyenne':''}</span><div class="bar"><i style="width:${Math.max(4,100*r.total/Math.max(...all.map(a=>a.total)))}%"></i></div><span class="cost-note">${amount(r.subscription)} d’abonnements<br>${amount(r.total-r.subscription)} de frais</span>${Math.abs(r.total-best.total)<.005?'<b class="best-tag">Le moins cher</b>':''}</div>`;return `<article class="plan"><h3>${s.name}</h3>${cell(s,'Shopify Payments','sp')}${state.compareExternal?cell(e,'PSP externe','psp'):''}<div class="difference" ${state.compareExternal?'':'hidden'}>${Math.abs(s.total-e.total)<.005?'Coût identique':`<strong>${amount(Math.abs(s.total-e.total))} / ${period}</strong> de moins avec<br>${s.total<e.total?'Shopify Payments':'le PSP externe'}`}</div></article>`}).join('');
  $('breakdown').innerHTML=`<table><caption>Montants ${view==='year'?'annuels':'mensuels moyens'}</caption><thead><tr><th>Configuration</th><th>Abonnements</th><th>Commissions PSP</th><th>Fixes par paiement</th><th>Frais tiers Shopify</th><th>Total</th></tr></thead><tbody>${sp.rows.flatMap((r,i)=>[{...r,provider:'Shopify Payments'},...(state.compareExternal?[{...psp.rows[i],provider:'PSP externe'}]:[])]).map(r=>`<tr><th scope="row">${r.name}<small>${r.provider}</small></th>${['subscription','processing','fixed','third','total'].map(k=>`<td>${amount(r[k])}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
  $('thresholds').innerHTML=[[sp,'Shopify Payments'],...(state.compareExternal?[[psp,'PSP externe']]:[])].map(([r,label])=>`<div><h4>${label}</h4>${r.thresholds.map(t=>`<div class="threshold"><span>${t.from} → ${t.to}</span><strong>${t.volume===null?'Pas de seuil calculable':`${money(t.volume/12)} / mois`}</strong></div>`).join('')}</div>`).join('');
 }catch(e){$('error').textContent=e.message;$('error').hidden=false;$('output').hidden=true;$('derived').textContent='';}
}
fields.forEach(id=>$(id).addEventListener('input',e=>{state[id]=e.target.type==='checkbox'?e.target.checked:e.target.type==='number'?(e.target.value===''?NaN:Number(e.target.value)):e.target.value;render();}));
root.querySelectorAll('[data-mode]').forEach(el=>el.addEventListener('change',e=>{if(e.target.value==='orders'&&state.basket>0){state.orderCount=Math.round(state.volume/state.basket);$('orderCount').value=state.orderCount;}else if(e.target.value==='basket'&&state.orderCount>0){state.basket=Number((state.volume/state.orderCount).toFixed(2));$('basket').value=state.basket;}state.inputMode=e.target.value;render();}));
$('rates').addEventListener('input',e=>{if(e.target.dataset.plan!==undefined){state.plans[Number(e.target.dataset.plan)][e.target.dataset.key]=e.target.value===''?NaN:Number(e.target.value);render();}});
for(const v of ['year','month'])$('view-'+v).addEventListener('click',()=>{view=v;for(const k of ['year','month'])$('view-'+k).setAttribute('aria-pressed',String(k===view));render();});
$('reset').addEventListener('click',()=>{state=structuredClone(defaults);fields.forEach(id=>{$(id).type==='checkbox'?$(id).checked=state[id]:$(id).value=state[id]});root.querySelector('[data-mode][value="basket"]').checked=true;rates();render();});rates();fields.forEach(id=>{if($(id).type!=='checkbox')$(id).value=state[id]});render();
}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-clients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-logo-slider')) {
  customElements.define('lb-logo-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.position = 0;
      this.measure = () => {
        this.loopWidth = this.querySelector('.lb-logo-set').getBoundingClientRect().width;
        this.scrollLeft = this.loopWidth;
        this.position = this.scrollLeft;
      };
      this.measure();
      this.tick = now => {
        this.frame = null;
        if (!this.isConnected || !this.visible || this.paused || this.hovered || this.focused || this.reduced.matches || this.drag) return;
        this.position += Math.min(now - (this.last || now), 40) * 0.027;
        if (this.position >= this.loopWidth * 2) this.position -= this.loopWidth;
        this.scrollLeft = this.position;
        this.last = now;
        this.frame = requestAnimationFrame(this.tick);
      };
      this.start = () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.position = this.scrollLeft;
        this.last = 0;
        this.frame = requestAnimationFrame(this.tick);
      };
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { this.hovered = false; this.start(); } }, options);
      this.addEventListener('focus', () => { this.focused = true; }, options);
      this.addEventListener('blur', () => { this.focused = false; this.start(); }, options);
      this.addEventListener('pointerdown', e => {
        this.drag = { x: e.clientX, lastX: e.clientX, moved: false, paused: this.paused, type: e.pointerType };
        this.paused = true;
        if (e.pointerType === 'mouse') { e.preventDefault(); this.setPointerCapture(e.pointerId); }
      }, options);
      this.addEventListener('pointermove', e => {
        if (!this.drag) return;
        if (Math.abs(e.clientX - this.drag.x) > 5) this.drag.moved = true;
        if (this.drag.type === 'mouse') {
          this.scrollLeft += this.drag.lastX - e.clientX;
          this.drag.lastX = e.clientX;
          this.normalize();
        }
      }, options);
      this.addEventListener('pointerup', () => {
        if (!this.drag) return;
        this.paused = this.drag.moved ? true : !this.drag.paused;
        this.drag = null;
        this.start();
      }, options);
      this.addEventListener('pointercancel', () => { this.drag = null; this.paused = true; }, options);
      this.addEventListener('scroll', () => { this.normalize(); }, { ...options, passive: true });
      this.addEventListener('wheel', () => { this.paused = true; }, { ...options, passive: true });
      this.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); this.paused = !this.paused; this.start(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.paused = true; this.scrollLeft += e.key === 'ArrowRight' ? 180 : -180; }
      }, options);
      window.addEventListener('resize', this.measure, options);
      this.reduced.addEventListener('change', this.start, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.start(); });
      this.observer.observe(this);
    }
    normalize() {
      if (!this.loopWidth) return;
      if (this.scrollLeft < 1) this.scrollLeft += this.loopWidth;
      else if (this.scrollLeft >= this.loopWidth * 2) this.scrollLeft -= this.loopWidth;
    }
    disconnectedCallback() {
      this.abort.abort();
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.lb-header details[open]').forEach((details) => {
    if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const active = document.activeElement;
  const menu = active?.closest('.lb-expertise-menu[open]') || active?.closest('.lb-mobile-menu[open]') || document.querySelector('.lb-header details[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
